const borderRadiusValue = '3px';

export default function getSelectLightStyles(colors) {
  return {
    control: (styles, { menuIsOpen }) => ({
      ...styles,
      height: '40.25px',
      background: colors.background.light,
      border: 'transparent',
      borderBottom: `1px solid ${colors.background.grey}`,
      borderColor: colors.background.grey,
      borderRadius: borderRadiusValue,
      borderBottomRightRadius: menuIsOpen ? '0' : borderRadiusValue,
      borderBottomLeftRadius: menuIsOpen ? '0' : borderRadiusValue,
      boxShadow: 'none',
      cursor: 'pointer',

      '&:hover': {
        borderColor: colors.background.grey,
      },
    }),
    placeholder: (styles) => ({
      ...styles,
      fontSize: '1.4em',
    }),
    menu: (styles) => ({
      ...styles,
      zIndex: '999',
      padding: '0',
      marginTop: '0',
      border: `1px solid ${colors.background.grey}`,
      borderWidth: '0 1px 1px 1px',
      borderRadius: borderRadiusValue,
      borderTopRightRadius: '0',
      borderTopLeftRadius: '0',
      boxShadow: '0px 3px 18px 0 rgba(0, 0, 0, 0.11)',
    }),
    menuList: (styles) => ({
      ...styles,
      padding: '0',
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isFocused ? colors.background.grey : colors.background.light,
      fontSize: '1.4em',
      fontWeight: isSelected ? 700 : 500,
      color: colors.text.default,
      cursor: 'pointer',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    }),
  };
}
